import React from 'react';
import { Grid, TextField, Autocomplete, Typography, Divider, Box } from '@mui/material';
import { 
  anesthesiologistOptions, 
  procedureOptions, 
  preoperativeOptions, 
  intraoperativeOptions, 
  postoperativeOptions 
} from '../constants/options';

const PlanSection = ({ patientData, setPatientData, errors, handlePatientChange, handleBlur }) => {
  return (
    <Box>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={6}>
          <Autocomplete
            options={anesthesiologistOptions}
            value={patientData.anesthesiologist || ""}
            onChange={(e, newVal) => setPatientData(prev => ({ ...prev, anesthesiologist: newVal }))}
            renderInput={(params) => (
              <TextField 
                {...params} 
                label="Anaesthesiologist" 
                name="anesthesiologist"
                required 
                error={!!errors.anesthesiologist}
                helperText={errors.anesthesiologist}
                onBlur={handleBlur}
              />
            )}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Autocomplete
            freeSolo
            options={procedureOptions}
            value={patientData.surgical_procedure || ""}
            onInputChange={(e, newVal) => setPatientData(prev => ({ ...prev, surgical_procedure: newVal }))}
            renderInput={(params) => (
              <TextField 
                {...params} 
                label="Surgical Procedure done" 
                name="surgical_procedure"
                required 
                error={!!errors.surgical_procedure}
                helperText={errors.surgical_procedure}
                onBlur={handleBlur}
              />
            )}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            fullWidth
            label="Surgeon"
            name="surgeon"
            value={patientData.surgeon || ''}
            onChange={handlePatientChange}
            multiline
            rows={2}
          />
        </Grid>
      </Grid>

      <Typography variant="h6" sx={{ mt: 4, mb: 2, color: '#008080', fontWeight: 600 }}>
        Plan of Perioperative Analgesia
      </Typography>
      <Divider sx={{ mb: 3 }} />

      <Grid container spacing={3}>
        <Grid item xs={12} sm={6}>
          <Autocomplete
            freeSolo
            options={preoperativeOptions}
            value={patientData.preoperative || ""}
            onInputChange={(e, newVal) => setPatientData(prev => ({ ...prev, preoperative: newVal }))}
            renderInput={(params) => (
              <TextField {...params} label="Preoperative" />
            )}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Autocomplete
            freeSolo
            options={intraoperativeOptions}
            value={patientData.intraoperative || ""}
            onInputChange={(e, newVal) => setPatientData(prev => ({ ...prev, intraoperative: newVal }))}
            renderInput={(params) => (
              <TextField {...params} label="Intraoperative" />
            )}
          />
        </Grid>
        <Grid item xs={12}>
          <Autocomplete
            freeSolo
            options={postoperativeOptions}
            value={patientData.postoperative || ""}
            onInputChange={(e, newVal) => setPatientData(prev => ({ ...prev, postoperative: newVal }))}
            renderInput={(params) => (
              <TextField 
                {...params} 
                label="Postoperative (Preemptive analgesia prescribed)" 
              />
            )}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default PlanSection;
